import * as Yup from 'yup';
import moment from 'moment';
import { TracesData } from '../components/traces/traces-create-edit';

export const traceSchema: Yup.ObjectSchema<TracesData> = Yup.object().shape({
  department: Yup.string().default('').required().label('Department'),
  traceDateFrom: Yup.object()
    .default(moment())
    .required()
    .label('Trace Date From'),
  traceDateTo: Yup.object()
    .default(moment().add(1, 'day'))
    .required()
    .label('Trace Date To'),
  traceTime: Yup.object().default(moment()).required().label('Trace Time'),
  displayTime: Yup.object().default(moment()).required().label('Display Time'),
  message: Yup.string().default('').required().label('Department'),
});
